
import React, { useState } from "react";
import InstitutionInfo from "./InstitutionInfo";
import StaffDetails from "./StaffDetails";
import InfrastructureForm from "./InfraStructureDetails";
import CourseIntakeDetails from "./ProgrammeIntake/CourseIntakeDetails";

export default function BasicDetails() {

    const steps = [
        { label: "Institute Details", icon: "🏫", component: <InstitutionInfo /> },
        { label: "Course Intake Details", icon: "🎓", component: <CourseIntakeDetails /> },
        { label: "Infrastructure", icon: "🏗️", component: <InfrastructureForm /> },
        { label: "Staff Details", icon: "👨‍🏫", component: <StaffDetails /> },
    ];

    const [activeStep, setActiveStep] = useState(0);
    return (
        <>

            {/* ✅ Next / Previous buttons */}
            <div className="d-flex justify-content-end gap-2 mt-3">
                {activeStep > 0 && (
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setActiveStep((prev) => prev - 1)}
                    >
                        ← Previous
                    </button>
                )}
                {activeStep < steps.length - 1 && (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setActiveStep((prev) => prev + 1)}
                    >
                        Next →
                    </button>
                )}
            </div>
            <div className="stepper-wrapper">


                <div className="stepper">
                    {steps.map((step, index) => {
                        const isActive = index === activeStep;
                        return (
                            <div className="step-item" key={index}>

                                <button
                                    type="button"
                                    className={`step-circle ${isActive ? "active" : ""}`}
                                // ✅ removed onClick — icon click disabled
                                >
                                    <span className="step-emoji">{step.icon}</span>
                                </button>

                                <div className={`step-label ${isActive ? "active-label" : ""}`}>
                                    {step.label}
                                </div>

                                {index !== steps.length - 1 && <div className="step-line" />}

                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="step-content">
                {steps[activeStep].component}
            </div>


        </>
    );
}